import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { connect } from 'react-redux';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import HomeIcon from '@material-ui/icons/Home';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';


class Header extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            online: true,
            expandClicked: true

        }
    }



    componentDidMount() {
        setInterval(() => {
            let isOnline = window.navigator.onLine;
            if (isOnline) {
                this.setState({ online: true })
            } else {
                this.setState({ online: false })
            }

        }, 5000);
    }

    render() {
        return (

            <AppBar position="absolute" color="background">
                <Toolbar class="toolbar">
                    <div class="toolbar-left">
                        <div class="with-gap">
                        <IconButton onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.setState({expandClicked: !this.state.expandClicked})
                            this.props.onMenuClick();
                        }} edge="start" color="inherit" aria-label="menu">
                            <h6 style={{color: '#283593', fontSize: '.9rem'}}>Содержание</h6>
                            {this.state.expandClicked ? <ExpandMoreIcon color="primary" /> : <ExpandLessIcon color="primary" />}
                        </IconButton>
                        </div>
                      
                        <a href="http://mbook.kz">
                            <div id="logo" ></div>
                          
                        </a>
                        
                        <div  className="with-gap primary_text header-title">
                            {this.props.title}
                        </div>
                    
                    </div>
                    <div class="toolbar-right">
                        <a href="/"  title="Домашняя страница">
                        <IconButton>
                            <HomeIcon color="primary" />
                      </IconButton>
                        </a>

                        <div id="navigation-arrow" style={{display:'flex'}}> 
                            <div className="header-tools-wrapper">
                                {this.renderNavigationButtonBackward()}
                            </div>
                            <div className="header-tools-wrapper with-gap">
                                {this.renderNavigationButtonForward()}
                            </div>
                        </div>
                        <div class="with-gap">

                        <IconButton  onClick={e => {
                                e.preventDefault();
                                this.props.onModalClick();
                            }} edge="start" color="inherit" aria-label="info">
                            <InfoIcon  color="primary" />
                        </IconButton>
                        </div>


                    </div>
                </Toolbar>
            </AppBar>
            // <div className="Header">
            //     <header id="header">
            //         <div className="row navigation-row">
            //             <div className="left-head-wrapper skewed-bg">
            //                 <div className="left-head">
            //                     <div className="content">
            //                         <a href="http://mbook.kz" id="logo"/>
            //                     </div>
            //                 </div>
            //             </div>

            //             <div className="right-head-wrapper">
            //                 <div className="right-head">
            //                     <div className="header-tools-wrapper home-icon">
            //                         <a href="http://mbook.kz" className="header-tools go-home"
            //                            title="Домашняя страница"/>

            //                     </div>
            //                     <div id="navigation-arrow">
            //                         <div className="header-tools-wrapper">
            //                             {this.renderNavigationButtonBackward()}
            //                         </div>
            //                         <div className="header-tools-wrapper">
            //                             {this.renderNavigationButtonForward()}
            //                         </div>
            //                     </div>
            //                     <div id="image-holder">
            //                         <img src={help} onClick={e => {
            //                             e.preventDefault();
            //                             this.props.onModalClick();
            //                         }}/>
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </header>
            // </div>
        )
    }

    renderNavigationButtonBackward = () => {
        if (this.props.navigation && this.props.navigation.previousItem && this.state.online) {
            const { previousItem } = this.props.navigation;
            // let link = "/viewer/course/" + parseInt(previousItem.courseId) + "/nodes/" + previousItem.nodeId + "/item/" + previousItem.item_id;
            let link = this.makeLink(parseInt(previousItem.courseId), previousItem.nodeId, previousItem.item_id);
            return (
                <Link
                    onClick={event => {
                        // event.preventDefault();
                        this.props.setCurrentItem(previousItem)
                    }}
                    className="header-tools back"
                    title="Назад"
                    to={
                        link
                    }
                />
            )
        } else {
            return null;
        }
    };

    makeLink = (courseId, nodeId, itemId) => {
        let initial = "/viewer/course/";
        return initial + courseId + "/nodes/" + nodeId + "/item/" + itemId;
    };


    renderNavigationButtonForward = () => {
        if (this.props.navigation && this.props.navigation.nextItem && this.state.online) {
            const { nextItem } = this.props.navigation;
            // let link = "/viewer/course/" + parseInt(nextItem.courseId) + "/nodes/" + nextItem.nodeId + "/item/" + nextItem.item_id;
            let link = this.makeLink(parseInt(nextItem.courseId), nextItem.nodeId, nextItem.item_id);
            return (
                <Link
                    onClick={event => {
                        // event.preventDefault();
                        this.props.setCurrentItem(nextItem)
                    }}
                    className="header-tools forward"
                    title="Вперед"
                    to={
                        link
                    }
                />
            )
        } else {
            return null;
        }
    }
}

const mapStateToProps = state => ({
    navigation: state.navigation,
    allElements: state.allElements,
    approved: state.approved,
});

export default connect(mapStateToProps)(Header);




// WEBPACK FOOTER //
// ./src/components/header/Header.js